import React from 'react';
import { observer } from 'mobx-react-lite';

interface HeaderPropsType {
    title: string;
    dataTest: string;
}

export const LoadingV2 = observer(({ title, dataTest }: HeaderPropsType) => {
    return (
        <div
            className='flex flex-col items-center justify-center flex-auto max-h-screen gap-6 p-6 bg-white font-tertiary flex-nowrap'
            data-test={dataTest}
        >
            <div className='w-8 h-8 border-4 border-dashed rounded-full animate-spin border-foreground' />
            <p className='m-0 text-sm text-foreground'>{title}</p>
        </div>
    );
});
